"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import PhoneNumberInput from "@/components/ui/phone-number-input";
import { FilterInputProps } from "./types";

/**
 * Phone number filter component with formatting.
 * Debounces input and applies after typing stops.
 */
const PhoneNumberFilter: React.FC<FilterInputProps> = t0 => {
  const $ = _c(15);
  const {
    value,
    onChange,
    focusRef,
    onSubmit
  } = t0;
  const [input, setInput] = useState(value || "");
  const debounceTimeoutRef = useRef(null);
  let t1;
  if ($[0] !== onChange) {
    t1 = newValue => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(() => {
        const valueToSet = newValue === "" ? undefined : newValue;
        onChange(valueToSet);
      }, 300);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const debouncedApply = t1;
  let t2;
  if ($[2] !== debouncedApply) {
    t2 = e => {
      const newValue_0 = e.target.value;
      setInput(newValue_0);
      debouncedApply(newValue_0);
    };
    $[2] = debouncedApply;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChange = t2;
  let t3;
  if ($[4] !== input || $[5] !== onChange || $[6] !== onSubmit) {
    t3 = e_0 => {
      if (e_0.key === "Enter") {
        e_0.preventDefault();
        if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
        }
        onChange(input === "" ? undefined : input);
        onSubmit?.();
      }
    };
    $[4] = input;
    $[5] = onChange;
    $[6] = onSubmit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleKeyDown = t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
    t5 = [];
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[10] !== focusRef || $[11] !== handleChange || $[12] !== handleKeyDown || $[13] !== input) {
    t6 = <PhoneNumberInput value={input} onChange={handleChange} onKeyDown={handleKeyDown} ref={focusRef} autoFocus={true} className="!border-none !bg-transparent !shadow-none !ring-0 focus:!ring-0" />;
    $[10] = focusRef;
    $[11] = handleChange;
    $[12] = handleKeyDown;
    $[13] = input;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default PhoneNumberFilter;